import { Modal, Progress } from "antd";
import React, { useState, useEffect, useCallback } from "react";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";
import heic2any from "heic2any"; // npm install heic2any
import ChantSpinner from "../../../CommonComponents/ChantSpinner/ChantSpinner";

const UploadConfirmationModal = (props) => {
  const {
    onCancel,
    isUploading,
    progress,
    onUploadImages,
    showUploadModal,
    files,
    removeImage,
  } = props;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [convertedImages, setConvertedImages] = useState([]);
  const [isConverting, setIsConverting] = useState(false);

  useEffect(() => {
    const convertImages = async () => {
      if (!files || files.length === 0) {
        setConvertedImages([]);
        return;
      }

      setIsConverting(true);
      const converted = [];

      for (const file of files) {
        try {
          const isHeicData =
            file.data &&
            (file.data.startsWith("data:image/heic") ||
              file.data.startsWith("data:image/heif") ||
              (file.file &&
                (file.file.type === "image/heic" ||
                  file.file.type === "image/heif" ||
                  file.file.name?.toLowerCase().endsWith(".heic") ||
                  file.file.name?.toLowerCase().endsWith(".heif"))));

          if (isHeicData && file.file) {
            try {
              const convertedBlob = await heic2any({
                blob: file.file,
                toType: "image/jpeg",
                quality: 0.9,
              });

              // Convert blob to base64 for display
              const reader = new FileReader();
              const base64Promise = new Promise((resolve) => {
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(convertedBlob);
              });

              const convertedData = await base64Promise;
              converted.push({ ...file, displayData: convertedData });
            } catch (error) {
              console.error("Error converting HEIC for display:", error);
              converted.push({ ...file, displayData: file.data });
            }
          } else {
            converted.push({ ...file, displayData: file.data });
          }
        } catch (error) {
          console.error("Error processing file:", error);
          converted.push({ ...file, displayData: file.data });
        }
      }

      setConvertedImages(converted);
      setIsConverting(false);
    };

    convertImages();
  }, [files]);

  useEffect(() => {
    if (currentIndex >= files.length && files.length > 0) {
      setCurrentIndex(files.length - 1);
    }
  }, [files.length, currentIndex]);

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleRemoveImage = useCallback(() => {
    const newCurrentIndex = currentIndex;

    if (files.length - 1 === currentIndex) {
      const updatedIndex = currentIndex - 1;
      setCurrentIndex(updatedIndex);
      removeImage(newCurrentIndex);
    } else {
      removeImage(newCurrentIndex);
    }
  }, [currentIndex, files.length, removeImage]);

  const handleThumbnailClick = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  let footer = [];
  if (isUploading) {
    footer.push(
      <div className="row" style={{ justifyContent: "center" }} key="progress">
        <div className="col-md-4">
          <Progress
            percent={progress ? progress : 0}
            status="active"
            showInfo={false}
          />
        </div>
      </div>
    );
  }
  if (!isUploading) {
    footer.push(
      <ChantButton
        type="secondary"
        key="back"
        disabled={isUploading}
        onClick={handleCancel}
      >
        Return
      </ChantButton>,
      <ChantButton
        key="submit"
        type="primary"
        disabled={isUploading}
        loading={isUploading}
        onClick={onUploadImages}
      >
        Submit
      </ChantButton>
    );
  }

  const displayImages = convertedImages.length > 0 ? convertedImages : files;

  return (
    <Modal
      open={showUploadModal}
      title="Confirm Upload"
      onOk={() => {}}
      onCancel={handleCancel}
      footer={footer}
      width={"80vw"}
    >
      {isConverting ? (
        <div className="flex-center" style={{ minHeight: "100px" }}>
          <ChantSpinner text="Converting images for preview..." />
        </div>
      ) : (
        <div className="row" style={{ flexDirection: "column" }}>
          <div
            className="row"
            style={{ justifyContent: "flex-end", paddingRight: 30, height: 30 }}
          >
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 30,
                width: 30,
              }}
            >
              {!isUploading && (
                <i
                  className="fa fa-trash fa-lg"
                  style={{ height: 30, width: 30 }}
                  onClick={handleRemoveImage}
                ></i>
              )}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: 350,
              backgroundImage: `url(${displayImages.length > 0 && (displayImages[currentIndex]?.displayData || displayImages[currentIndex]?.data)})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></div>
          <div
            className="row"
            style={{ overflow: "scroll", padding: "5px 15px" }}
          >
            {displayImages &&
              displayImages.map((file, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      margin: 10,
                      width: 50,
                      height: 50,
                      cursor: "pointer",
                    }}
                    onClick={() => handleThumbnailClick(index)}
                  >
                    {file.displayData ? (
                      <img
                        src={file.displayData}
                        alt="thumbnail"
                        height={50}
                        width={50}
                        style={{
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div>
                        <ChantSpinner size="small" />
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default UploadConfirmationModal;
